export default {
  LIST(state, data) {
    state.additionalExams = data
  },
  GET(state, data) {
    state.additionalExam = { ...data }
  },
}
